import { EvalIds, ProductNameType } from "graphql/generated";

export const OTC_ZOEY_PRODUCTS = [
  "grow_zoey",
  "bump",
  "pregnancy_test_kit",
  "preg_o_bundle",
  "ovulation_test_kit"
];

// need to go flow add to cart -> add to OTC_PRODUCTS
export const CONSULT_ONLY_NO_EVAL = [
  EvalIds.CovidTeleconsult,
  EvalIds.SexTherapy,
  EvalIds.SexTherapyZoey
];

export const OTC_PRODUCTS = [
  "vigour_noah",
  "grow",
  "grow_zoey",
  "fresh",
  "sona2",
  // "f1s",
  "personal_moisturiser",
  ...OTC_ZOEY_PRODUCTS,
  "fertility_hormone_test",
  "gynae_hormone_test",
  "sleep_thins",

  "good_head_shampoo",
  "smooth_head_conditioner",
  "the_head_starter",

  ...CONSULT_ONLY_NO_EVAL
];

export const OTC_PRODUCTS_HK = [
  "vigour_noah",
  "fresh",
  "good_head_shampoo",
  "smooth_head_conditioner",
  "the_head_starter",
  "sleep_thins"
];

export enum ProductStatus {
  active = "active",
  archived = "archived"
}
export const PRODUCT_FILTER_TYPE_STATUS = "product_status";

export const PRODUCT_IMAGE_DIRECTION = ["Noah-Wide", "Noah-Vertical", "Zoey-Wide", "Zoey-Vertical"];

const CONSULT_NO_EVAL_MAPPING = {
  covid_teleconsult: ProductNameType.CovidTeleconsult,
  sex_therapy: ProductNameType.SexTherapy,
  sex_therapy_zoey: ProductNameType.SexTherapy
};

export const STRIPE_PRODUCT_MAPPING = {
  vigour_noah: ProductNameType.Vigour,
  grow: ProductNameType.Grow,
  grow_zoey: ProductNameType.Grow,
  fresh: ProductNameType.FreshWipes,
  f1s: ProductNameType.NoahXLeloF1sBundle,
  sona2: ProductNameType.ZoeyXLeloSona2Bundle,
  personal_moisturiser: ProductNameType.PersonalMoisturiser,
  pregnancy_test_kit: ProductNameType.PregnancyTestKit,
  ovulation_test_kit: ProductNameType.OvulationTestKit,
  preg_o_bundle: ProductNameType.PregOBundle,
  bump: ProductNameType.Bump,
  fertility_hormone_test: ProductNameType.FertilityHormoneTestKit,
  gynae_hormone_test: ProductNameType.GynaeConsultHormoneTest,
  sleep_thins: ProductNameType.SleepThins,

  good_head_shampoo: ProductNameType.GoodHeadShampoo,
  smooth_head_conditioner: ProductNameType.SmoothHeadConditioner,
  the_head_starter: ProductNameType.TheHeadStarter,

  // need to go flow add to cart -> like otc sub flow
  ...CONSULT_NO_EVAL_MAPPING
};

export const isProductOTC = (productUniqName: ProductNameType | string) => {
  return [...OTC_PRODUCTS, ...OTC_PRODUCTS_HK]
    .map((product) => STRIPE_PRODUCT_MAPPING[product])
    .includes(productUniqName);
};
